import { useState } from 'react';
import { Search, Bell, ChevronDown, LogOut, UserCircle } from 'lucide-react';
import { useAuthStore } from '../lib/auth-store';
import { logout } from '../lib/api';
import { useNavigate } from 'react-router-dom';

export function Topbar() {
  const user = useAuthStore((s) => s.user);
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  const initials = user?.name
    ? user.name
        .split(' ')
        .slice(0, 2)
        .map((s) => s[0]?.toUpperCase())
        .filter(Boolean)
        .join('')
    : 'A';

  const roleLabel = ({
    admin: 'Administrador',
    supervisor: 'Supervisor',
    agent: 'Agente',
    customer: 'Cliente',
  } as Record<string, string>)[user?.role ?? 'agent'] ?? user?.role;

  return (
    <header className="h-16 shrink-0 border-b border-slate-200 bg-white/70 backdrop-blur sticky top-0 z-10">
      <div className="h-full px-6 lg:px-10 flex items-center gap-4">
        <div className="flex-1 max-w-xl relative">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            type="text"
            placeholder="Buscar tickets, clientes, códigos (TCK-…)…"
            className="w-full pl-9 pr-3 py-2 text-sm rounded-lg border border-slate-200 bg-slate-50 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 focus:bg-white transition"
          />
          <kbd className="hidden sm:block absolute right-2 top-1/2 -translate-y-1/2 text-[10px] font-mono text-slate-400 border border-slate-200 rounded px-1.5 py-0.5 bg-white">
            ⌘K
          </kbd>
        </div>

        <div className="flex items-center gap-1">
          {/* Notificaciones: implementadas en M9+ (web push + lista). Por ahora
              el ícono queda como anchor visual sin badge falso. */}
          <button
            className="relative p-2 rounded-lg text-slate-500 hover:bg-slate-100"
            title="Notificaciones (próximamente)"
          >
            <Bell size={18} />
          </button>

          <div className="relative">
            <button
              onClick={() => setMenuOpen((v) => !v)}
              className="flex items-center gap-2 pl-2 pr-1.5 py-1 rounded-lg hover:bg-slate-100"
            >
              <div className="h-7 w-7 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 text-white text-xs font-semibold grid place-items-center">
                {initials}
              </div>
              <div className="hidden sm:block text-left leading-tight">
                <div className="text-xs font-medium text-slate-900">{user?.name ?? 'Usuario'}</div>
                <div className="text-[10px] text-slate-500">{roleLabel}</div>
              </div>
              <ChevronDown size={14} className="text-slate-400" />
            </button>

            {menuOpen && (
              <>
                <div
                  className="fixed inset-0 z-20"
                  onClick={() => setMenuOpen(false)}
                  aria-hidden
                />
                <div className="absolute right-0 mt-1 w-52 bg-white rounded-lg shadow-lg border border-slate-200 z-30">
                  <div className="px-3 py-2 border-b border-slate-100">
                    <div className="text-xs font-medium text-slate-900 truncate">
                      {user?.email}
                    </div>
                    <div className="text-[10px] text-slate-500">{roleLabel}</div>
                  </div>
                  <button
                    onClick={() => {
                      setMenuOpen(false);
                      navigate('/admin/settings/profile');
                    }}
                    className="w-full px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 flex items-center gap-2 border-b border-slate-100"
                  >
                    <UserCircle size={14} />
                    Mi perfil
                  </button>
                  <button
                    onClick={handleLogout}
                    className="w-full px-3 py-2 text-sm text-rose-600 hover:bg-rose-50 flex items-center gap-2"
                  >
                    <LogOut size={14} />
                    Cerrar sesión
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
